import { assetBaseUrl } from "."
import {
	PropertyContentReferenceMedia,
	QBankImage,
} from "../@types/CapioWeb/core"

export const imagePath = (imageUrl: string): string => {
	return assetBaseUrl() + imageUrl + "?format=webp"
}

interface ImageDataToImageProps {
	title: string
	alt: string
	src: string
	srcSet: string
	sizes: string
	loading: "lazy" | "eager"
	cover?: "true" | "false"
}

interface ImageSizeProps {
	width: number
	breakpoint: number
}

export const imageBlockDataToImageProps = (
	qbankImage: QBankImage,
	cover = false,
	lazy = true,
	srcSetSizes?: ImageSizeProps[]
): ImageDataToImageProps => {
	return imageUrlToImageProps(
		qbankImage?.media?.value?.url,
		qbankImage?.imageTitle?.value,
		qbankImage?.alternateText?.value,
		cover,
		lazy,
		srcSetSizes
	)
}

export const imageReferenceToImageProps = (
	media: PropertyContentReferenceMedia,
	title: string,
	altText: string,
	cover = false,
	lazy = true,
	srcSetSizes?: ImageSizeProps[]
): ImageDataToImageProps => {
	return imageUrlToImageProps(
		media?.value?.url,
		title,
		altText,
		cover,
		lazy,
		srcSetSizes
	)
}

export const imageUrlToImageProps = (
	media: string,
	title: string,
	altText: string,
	cover = false,
	lazy = true,
	srcSetSizes?: ImageSizeProps[]
): ImageDataToImageProps => {
	return {
		title: title,
		alt: altText,
		src: imagePath(media),
		srcSet: getSrcSets(media, srcSetSizes),
		sizes: getSrcSetSizes(srcSetSizes),
		loading: lazy ? "lazy" : "eager",
		cover: cover ? "true" : "false",
	}
}

function getSrcSets(imageUrl: string, srcSetSizes?: ImageSizeProps[]): string {
	const on = true
	if (on) {
		return srcSetSizes
			? srcSetSizes
					.map((size) => {
						return getSrcSet(imageUrl, size.width, size.breakpoint)
					})
					.join(", ")
			: ""
	}
	return ""
}

function getSrcSetSizes(srcSetSizes?: ImageSizeProps[]): string {
	const on = true
	if (on) {
		return srcSetSizes
			? srcSetSizes
					.map((size) => `(max-width: ${size.breakpoint}) ${size.width}`)
					.join(", ")
			: ""
	}

	return ""
}

function getSrcSet(
	imageUrl: string,
	width: number,
	breakpoint: number
): string {
	return `${imagePath(imageUrl)}&width=${width}&rmode=min ${breakpoint}w`
}
